<div>
	<span *ngFor="let mdValue of item?.allMetadata(['dc.identifier.doi'])">
	<h5>Metrics</h5>
   		<a href="https://plu.mx/plum/a/?doi={{mdValue.value}}" data-popup="right" data-size="medium" data-badge="true" class="plumx-plum-print-popup plum-bigben-theme" data-site="plum"></a>
    	<div data-badge-popover="right" data-badge-type="1" class="altmetric-embed"></div>    		
    <br>
    </span>
</div>